module.exports = __webpack_public_path__ + "img/foresters-financial-img-desktop.d0a9a9e9.svg";